import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/new_ui/Modal/Modal';

import { Button } from 'react-bootstrap5';

import { Formik, Form as FormikForm } from 'formik';
import SubmitButton from 'components/Widgets/SubmitButton';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import Emoji from 'components/Members/RequiredActions/SessionsFeedback/Slides/Emoji';
import Alert from 'components/new_ui/Alerts/alert';
import { useContext } from '../Context';

export default function Index({ show, onClose }) {
  const { actions, state } = useContext();

  const [rate, setRate] = useState(0);

  const onSkip = () => {
    setRate(0);
    onClose();
  };

  const onSave = (values, { setSubmitting }) => {
    if (rate === 0) {
      Alert({
        text: "We'd love to know what you think! Please select an emoji before proceeding to the next step.",
      });
      setSubmitting(false);

      return;
    }

    actions.saveFeedback(state.currentChatId, state.token, {
      rate,
      comment: values.comment,
    }, () => {
      setSubmitting(false);
      setRate(0);
      onClose();
    });
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onClose}
    >
      <h3>
        How did you feel about the AI coaching session?
      </h3>
      <p className="mt-3 mb-3">
        Please select the emoji that represents the best your reaction after the
        session.
      </p>
      <Emoji selectedPosition={rate} setRate={setRate} />
      <Formik
        initialValues={{
          comment: '',
        }}
        onSubmit={onSave}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <HorizontalTextField
              as="textarea"
              name="comment"
              placeholder="Private Comment"
              label=""
              rows="4"
            />

            <footer className="d-flex justify-content-between">
              <Button
                variant="outline-primary"
                onClick={onSkip}
                disabled={isSubmitting}
              >
                Skip
              </Button>
              <SubmitButton loading={isSubmitting}>
                Save
              </SubmitButton>
            </footer>

          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}

Index.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
